/* eslint-disable no-template-curly-in-string */
/*
  This file is automagically generated; please do not make any changes.
  - To update, run `yarn generate-docs` from the ./lib directory.
  - To override, add a corresponding .js file in components-override.

  Please refer to the `new-components-guide.md` for full instructions!
*/

let generatedDocs = {
  muiName: "Accordion",
  description: "",
  displayName: "Accordion",
  methods: [],
  props: {
    children: {
      type: {
        name: "custom",
        raw:
          "chainPropTypes(PropTypes.node.isRequired, props => {\n  const summary = React.Children.toArray(props.children)[0];\n\n  if (isFragment(summary)) {\n    return new Error(\"Material-UI: The Accordion doesn't accept a Fragment as a child. \" + 'Consider providing an array instead.');\n  }\n\n  if (! /*#__PURE__*/React.isValidElement(summary)) {\n    return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');\n  }\n\n  return null;\n})"
      },
      required: false,
      description: "The content of the accordion."
    },
    classes: {
      type: {
        name: "custom",
        raw:
          "chainPropTypes(PropTypes.object, props => {\n  if (props.classes && props.classes.focused) {\n    throw new Error(['Material-UI: the classes.focused key is deprecated.', 'Use `classes.focusedVisible` instead', 'The name of the pseudo-class was changed for consistency.']).join('\\n');\n  }\n\n  return null;\n})"
      },
      required: false,
      description:
        "Override or extend the styles applied to the component.\r\nSee [CSS API](#css) below for more details."
    },
    className: {
      type: { name: "string" },
      required: false,
      description: "@ignore"
    },
    defaultExpanded: {
      type: { name: "bool" },
      required: false,
      description: "If `true`, expands the accordion by default.",
      defaultValue: { value: "false", computed: false }
    },
    disabled: {
      type: { name: "bool" },
      required: false,
      description:
        "If `true`, the accordion will be displayed in a disabled state.",
      defaultValue: { value: "false", computed: false }
    },
    expanded: {
      type: { name: "bool" },
      required: false,
      description:
        "If `true`, expands the accordion, otherwise collapse it.\r\nSetting this prop enables control over the accordion."
    },
    onChange: {
      type: { name: "func" },
      required: false,
      description:
        "Callback fired when the expand/collapse state is changed.\r\n\r\n@param {object} event The event source of the callback.\r\n@param {boolean} expanded The `expanded` state of the accordion."
    },
    square: {
      type: { name: "bool" },
      required: false,
      description: "If `true`, rounded corners are disabled.",
      defaultValue: { value: "false", computed: false }
    },
    TransitionComponent: {
      type: { name: "elementType" },
      required: false,
      description:
        "The component used for the collapse effect.\r\n[Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.",
      defaultValue: { value: "Collapse", computed: true }
    },
    TransitionProps: {
      type: { name: "object" },
      required: false,
      description:
        "Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element."
    }
  },
  styles: {
    root: { description: "Styles applied to the root element." },
    rounded: {
      description: "Styles applied to the root element if `square={false}`."
    },
    expanded: {
      description: "Styles applied to the root element if `expanded={true}`."
    },
    disabled: {
      description: "Styles applied to the root element if `disabled={true}`."
    }
  }
};
export default generatedDocs;
